import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

const PROGRAM_FILTERS_KEY = 'agents.ams.programFilters'
export const DEFAULT_STATUS_FILTER = ['OPEN']

export type ProgramSearchFilters = {
  q: string
  campuses: string[]
  startDates: string[]
  statuses: string[]
  pageNumber: string,
  perPage?: string
}

export function useProgramFilterSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams()
  const filters = getFilters()

  useEffect(() => {
    saveFilters(filters)
    // eslint-disable-next-line
  }, [])

  function getFilters() {
    if (
      searchParams.get('q') === null &&
      searchParams.get('campuses') === null &&
      searchParams.get('startDates') === null &&
      searchParams.get('statuses') === null
    ) {
      const storedFilters = window.localStorage.getItem(PROGRAM_FILTERS_KEY)
      if (storedFilters !== null) {
        try {
          const storedFilterObj = JSON.parse(storedFilters)
          return storedFilterObj
        } catch (e) {
          console.error('Error parsing stored filters', e)
        }
      }
    }

    const paramsFilters = {
      q: searchParams.get('q') || '',
      campuses: searchParams.getAll('campuses'),
      startDates: searchParams.getAll('startDates'),
      statuses: DEFAULT_STATUS_FILTER,
      pageNumber: searchParams.get('pageNumber') || '1',
      perPage: searchParams.get('perPage') || '10',
    }

    return paramsFilters
  }

  function saveFilters(saveFilters: ProgramSearchFilters) {
    const updateSearchParams = (searchParams: URLSearchParams, filters: ProgramSearchFilters) => {
      for (const [key, value] of Object.entries(filters)) {
        if (Array.isArray(value)) {
          searchParams.delete(key)
          value.forEach(v => searchParams.append(key, v))
        } else {
          searchParams.set(key, value)
        }
      }
      return searchParams
    }

    setSearchParams(searchParams => {
      const updatedSearchParams = updateSearchParams(searchParams, saveFilters)
      return updatedSearchParams
    })
    window.localStorage.setItem(PROGRAM_FILTERS_KEY, JSON.stringify(saveFilters))
  }

  function updateFilters(newFilters: Partial<ProgramSearchFilters>) {
    saveFilters({
      ...getFilters(),
      ...newFilters,
    })
  }

  function clearFilters() {
    saveFilters({
      q: '',
      campuses: [],
      startDates: [],
      statuses: DEFAULT_STATUS_FILTER,
      pageNumber: '1',
      perPage: '10',
    })
  }

  return {
    filters,
    updateFilters,
    clearFilters,
  }
}
